<div class="loginBG">
  <img style="width: 100%;height: 100%;position: absolute;" src="assets/images/login/background.png" />
  <div class="sideImgContainer">
    <!-- <img class="sideImg" src="assets/images/login/login-background.svg"> -->
  </div>
  <div class="loginDialog">
    <!-- <img src="assets/images/login/slogan.png" class="slogan-img"> -->
    <div class="login-view">
      <!-- <ng-container *ngIf="showWxCode">
        <iframe id='iframe_panel' name='iframe_panel' class='iframe_panel' width="100%" height="422px" frameborder="no"
          [src]="iframeSrc" scrolling="yes" marginwidth="0" marginheight="0">
        </iframe>
      </ng-container> -->
      <div id='iframe_panel2' name='iframe_panel' class='iframe_panel' class="wxLogin" *ngIf="showWxCode">
      </div>


      <ng-container *ngIf="!(loginType === 'tenant'&&tenantList && tenantList.length > 0)||(loginType==='tenant'&&loginStatus!='login')" id='wxCode'>
        <div class="code-view"  *ngIf="loginType === 'tenant'">
        </div>
        <!-- (click)="showWx()" -->
        <img [src]="showWxCode?'assets/images/login/pcLogin.png':'assets/images/login/qcode.png'" class="qcode-img"
        *ngIf="loginType !== 'admin'" />
        <ng-container *ngIf="!showWxCode">
          <div class="title">{{product==='YC'?'数企通':'易享云'}} 欢迎您</div>
          <div *ngIf="loginType !== 'tenant'" style="height: 20px;"></div>
          <!-- <div class="welcome">欢迎你</div> -->
        </ng-container>
      </ng-container>
      <ng-container *ngIf="loginType === 'tenant'">
        <ng-container *ngIf="tenantList && tenantList.length > 0&&loginStatus=='login'">
          <ng-container *ngTemplateOutlet="tenantListContent"></ng-container>
        </ng-container>
        <ng-container *ngIf="!showWxCode">
          <ng-container *ngIf="!tenantList||loginStatus!='login'">
            <nz-tabset nzCentered [(nzSelectedIndex)]="tabSelectIndex">
              <nz-tab nzTitle="密码登录">
                <form class="homeloginForm" nz-form [formGroup]="pwdLoginForm">
                  <nz-form-item>
                    <nz-form-control nzHasFeedback nzErrorTip="必填字段">
                      <div class="input-view">
                        <img src="assets/images/login/phone.png" />
                        <input placeholder="{{'请输入手机号' | translate}}" formControlName="mobile"
                          [(ngModel)]="tenantUser.mobile" maxlength="11">
                      </div>
                    </nz-form-control>
                  </nz-form-item>

                  <nz-form-item>
                    <nz-form-control nzHasFeedback nzErrorTip="必填字段">
                      <div class="input-view">
                        <img src="assets/images/login/pwd.png" />
                        <input placeholder="{{'请输入密码' | translate}}" type="password" formControlName="pwd"
                          [(ngModel)]="tenantUser.pwd" (keyup.enter)="tenantLogin()">
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                  <nz-alert *ngIf="error" nzType="error" [nzMessage]="error"></nz-alert>
                  <nz-alert *ngIf="hintMessage" nzType="warning" [nzMessage]="hintMessage"></nz-alert>
                </form>
              </nz-tab>
              <nz-tab nzTitle="验证码登录">
                <form class="homeloginForm" nz-form [formGroup]="tenantLoginForm">
                  <nz-form-item>
                    <nz-form-control nzHasFeedback nzErrorTip="必填字段">
                      <div class="input-view">
                        <img src="assets/images/login/phone.png" />
                        <input placeholder="{{'请输入手机号' | translate}}" formControlName="mobile"
                               [(ngModel)]="tenantUser.mobile">
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                  <div style="display: flex;justify-content: space-between;">
                    <nz-form-item>
                      <nz-form-control nzHasFeedback nzErrorTip="必填字段">
                        <div style="display: flex;align-items: flex-start;">
                          <div class="input-view" style="width: 206px;">
                            <img src="assets/images/login/code.png" />
                            <input placeholder="{{'请输入验证码' | translate}}" formControlName="smsCode" required
                                   (keyup.enter)="tenantLogin()" [(ngModel)]="tenantUser.smsCode">
                          </div>
                        </div>
                      </nz-form-control>
                    </nz-form-item>
                    <button class="m-l-sm" [disabled]="isSmsCodeSent" nz-button nzType="primary" nzSize="default"
                            nzShape="round" (click)="sendSmsCode()" style="width: 102px;height: 40px;font-size: 14px;">
                      <span *ngIf="!isSmsCodeSent">获取验证码</span>
                      <span *ngIf="isSmsCodeSent">{{countDownNum}}秒后重试</span>
                    </button>
                  </div>
                  <nz-alert *ngIf="error" nzType="error" [nzMessage]="error"></nz-alert>
                  <nz-alert *ngIf="hintMessage" nzType="warning" [nzMessage]="hintMessage"></nz-alert>
                </form>
              </nz-tab>
            </nz-tabset>
            <button class="m-t-sm" nz-button nzType="primary" nzSize="default" style="height: 40px;font-size: 16px;"
              [nzLoading]="loading" nzShape="round" nzBlock (click)="tenantLogin()">{{'登录' | translate}}</button>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="loginType === 'admin'">
        <form id="homeloginForm" class="homeloginForm" nz-form [formGroup]="validateForm">

          <nz-form-item>
            <nz-form-control [nzSpan]="24" nzHasFeedback nzErrorTip="Username is required">
              <div class="input-view">
                <img src="assets/images/login/phone.png" />
                <input placeholder="{{'请输入用户名' | translate}}" formControlName="username" [(ngModel)]="model.username">
              </div>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control [nzSpan]="24" nzHasFeedback nzErrorTip="Password is required">
              <div class="input-view">
                <img src="assets/images/login/pwd.png" />
                <input placeholder="{{'请输入密码' | translate}}" type="password" formControlName="password"
                  (keyup.enter)="login()" [(ngModel)]="model.password">
              </div>
            </nz-form-control>
          </nz-form-item>
          <nz-alert *ngIf="error" nzType="error" [nzMessage]="error"></nz-alert>
        </form>
        <button class="m-t-sm" nz-button nzType="primary" nzSize="default" style="height: 40px;font-size: 16px;"
          nzShape="round" [nzLoading]="loading" nzBlock (click)="login()">{{'登录' | translate}}</button>
      </ng-container>
      <img src="assets/images/login/logo.png" style="width: 100px;margin-left: auto;padding-top: 30px;"/>
    </div>
  </div>
</div>
<!-- <div class="browser-tips-wrap" *ngIf="browserTips">
  <div class="browser-tips">
      <div class="browser-tips-img"></div>
      <div class="browser-tips-text">
        系统检测到您的浏览器不适用于系统的运行<br/>
        为保证您更好的使用体验，请使用 Chrome 浏览器或火狐浏览器
      </div>
    <div class="browser-tips-button">
      <button nz-button nzType="default" class="browser-button-item" (click)="downloadBrowser(1)">去官网下载</button>
      <button nz-button nzType="primary" class="browser-button-item" (click)="downloadBrowser(2)">下载安装包</button>
    </div>
  </div>
</div> -->
<ng-template #tenantListContent>
  <div class="back-view">
    <img src="assets/images/login/back.png">
    <a (click)="clearTenantLogin()">返回登录</a>
  </div>

  <h2 class="m-b-md m-t-md" style="font-weight: bold;">选择你所在公司</h2>
  <div class="tenantList" *ngFor="let t of tenantList" (click)="loginCompany(t)">
    <!-- <nz-avatar nzSize="small" nzIcon="user" [nzSrc]="t.logo"></nz-avatar> -->
    <img src="assets/images/login/company.svg" style="width: 50px;height: 26px;"/>
    <h3>{{t.tenantName}}</h3>
  </div>
</ng-template>
<ng-template #addUserPassword>
    <input  nz-input placeholder="{{'请输入密码（6个字符）' | translate}}" [(ngModel)]="userPassword">
</ng-template>
<ng-template #addUserPasswordFooter>
  <button nz-button nzType="default"  (click)="this.addPasswordModal.destroy()">取消</button>
  <button nz-button nzType="primary"  (click)="handleAddPassword()">确认</button>
</ng-template>
